const routes = [
	{
		pageName: "Menu",
		pageLabel: "Menu",
		pageLink: "/",
		ifSubnav: true,
	},
	{
		pageName: "Invite your friends",
		pageLabel: "Invite",
		pageLink: "/invite-friends",
	},
	{
		pageName: "Favorite",
		pageLabel: "Favorite",
		pageLink: "/favorites",
	},
	{
		pageName: "Profile",
		pageLabel: "Profile",
		pageLink: "/profile",
	},
	{
		pageName: "Subscription",
		pageLabel: "Subscription",
		pageLink: "/subscription",
	},
];

export default routes;
